import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { VaultGate } from "@/features/vault/components/vault-gate";
import { VaultPage } from "@/features/vault/components/vault-page";

/**
 * Home = the vault. The gate displays setup (initial launch) / unlock
 * (locked) / item list (unlocked). Local-first: a guest
 * can create their vault and items completely offline.
 */
function VaultHomePage() {
  return (
    <VaultGate>
      <VaultPage />
    </VaultGate>
  );
}

export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  component: VaultHomePage,
});
